module.exports = __webpack_public_path__ + "img/global_rotate.7b08233e.svg";